import { localeFormatDefault } from '@/plugins/date-print';
import BaseModel from './base';

export default class UserPortfolio extends BaseModel {
  constructor(portfolio, url) {
    super(portfolio, url);

    this.owner_id = portfolio.owner_id;
    this.url = portfolio.url;
    this.original_name = portfolio.original_name;
    this.created_at = portfolio.created_at;
    this.description = portfolio.description;
    this.updated_at = portfolio.updated_at;

    this.valid_before_at = portfolio.valid_before_at && localeFormatDefault(portfolio.valid_before_at);
    this.name = this.description ?? this.original_name;
  }

  get isValid() {
    const { valid_before_at } = this;
    if (!valid_before_at) return true;
    return new Date(valid_before_at) > new Date();
  }
}
